import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LandingPage } from './components/LandingPage';
import { PrivacyPage } from './components/PrivacyPage';
import { Header } from './components/Header';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<LandingPage data-id="element-3" />} data-id="element-2" />
        <Route path="/privacy" element={<div className="w-full min-h-screen bg-background" data-id="element-5">
              <Header data-id="element-6" />
              <PrivacyPage data-id="element-7" />
            </div>} data-id="element-4" />
      </Routes>
    </BrowserRouter>;
}